<template>
  <div
    class="count-title"
    :title="showDesc"
    v-if="questions.length>0 && isShowDesc"
    v-html="showDesc"
  ></div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ExamThemeTitle',
  props: {
    isShowDesc: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['questions', 'currentQuestionType', 'currentQuestionIndex']),
    showDesc(){
      const len = this.questions[this.currentQuestionType].list.length
      const idx = this.currentQuestionIndex + 1
      return `共<span style="color:red;">${len}</span>题，第<span style="color:red;">${idx}</span>题`
    }
  }
}
</script>
<style lang="scss" scoped>
.count-title {
  float: right;
  display: inline-block;
  height: 33px;
  font-size: 14px;
  font-weight: 700;
  padding-left: 18px;
  padding-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
